// extracted by mini-css-extract-plugin
module.exports = {"containing":"userrole_containing__2fcQL","buttonAdd":"userrole_buttonAdd__2M8Op"};